<div
  class="flex flex-col gap-3 rounded-md border border-[#ece8e4] bg-white p-4">
  <div class="text-xs font-semibold tracking-[0.08em] text-gray-500 uppercase">
    Kosmetyki z ankiety
  </div>

  <div class="flex flex-col gap-3">
    @for (group of groups(); track group.name) {
      <section
        class="flex flex-col gap-3 rounded-md border border-gray-200 bg-gray-50 p-4">
        <div
          class="text-xs font-semibold tracking-[0.08em] text-gray-500 uppercase">
          {{ group.name }}
        </div>

        @if (group.isRandomSelected) {
          <div
            class="rounded-md border border-dashed border-gray-300 bg-white p-3 text-sm font-medium text-gray-500">
            Losowo dobrane kosmetyki
          </div>
        } @else {
          <app-admin-order-components-list [components]="group.components" />
        }
      </section>
    }
  </div>
</div>
